import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initCards = () => {
	const cards = document.querySelectorAll('[data-cards]')

	if (window.innerWidth < 650) return

	cards.forEach(card => {

		ScrollTrigger.create({
			trigger: card,
			start: 'top bottom',
			once: true,
			onEnter: () => {
				setupScale()
			}
		})

		function setupScale() {			
			const items = card.querySelectorAll('.cards__item')
	
			items.forEach(item => {
				gsap.fromTo(item, {
					scale: 1.2
				}, {
					scale: 1,
					ease: 'power1.inOut',
					scrollTrigger: {
						trigger: item,
						start: 'top bottom',
						end: 'center center',
						scrub: true
					}
				})
			})
		}
	})
}

export default () => {}